import React from 'react';
import Svg, { Path } from 'react-native-svg';
import { IconProps } from 'shared/components/vxl/icon/Icon/Icon';

export default function Placeholder({
  iconColor,
  iconSize,
  iconAccessibilityLabel,
}: IconProps) {
  return (
    <Svg
      accessibilityLabel={iconAccessibilityLabel}
      width={iconSize}
      height={iconSize}
      viewBox="0 0 24 24"
    >
      <Path d="M3 21H5V19H3V21Z" fill={iconColor} />
      <Path d="M7 21H9V19H7V21Z" fill={iconColor} />
      <Path d="M11 21H13V19H11V21Z" fill={iconColor} />
      <Path d="M15 21H17V19H15V21Z" fill={iconColor} />
      <Path d="M19 21H21V19H19V21Z" fill={iconColor} />
      <Path d="M7 13H9V11H7V13Z" fill={iconColor} />
      <Path d="M15 13H17V11H15V13Z" fill={iconColor} />
      <Path d="M3 5H5V3H3V5Z" fill={iconColor} />
      <Path d="M7 5H9V3H7V5Z" fill={iconColor} />
      <Path d="M11 5H13V3H11V5Z" fill={iconColor} />
      <Path d="M15 5H17V3H15V5Z" fill={iconColor} />
      <Path d="M19 5H21V3H19V5Z" fill={iconColor} />
      <Path d="M3 9H5V7H3V9Z" fill={iconColor} />
      <Path d="M11 9H13V7H11V9Z" fill={iconColor} />
      <Path d="M19 9H21V7H19V9Z" fill={iconColor} />
      <Path d="M3 17H5V15H3V17Z" fill={iconColor} />
      <Path d="M11 17H13V15H11V17Z" fill={iconColor} />
      <Path d="M19 17H21V15H19V17Z" fill={iconColor} />
    </Svg>
  );
}
